import React from "react";
import { X } from "lucide-react";

export const inputCls = "w-full bg-[color:var(--app-bg)] border border-[color:var(--border-subtle)] px-3 py-2 text-sm text-white focus:border-gold focus:outline-none transition-colors duration-200";

export const money = (n) => `$${Number(n || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const fmtDate = (s) => (s ? new Date(s).toLocaleString([], { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" }) : "—");

export function Drawer({ title, onClose, children, testid }) {
  return (
    <div className="fixed inset-0 z-50 flex justify-end" data-testid={testid}>
      <div className="absolute inset-0 bg-black/60" onClick={onClose} />
      <div className="relative w-full max-w-md h-full surface overflow-y-auto p-5 animate-in slide-in-from-right duration-300">
        <div className="flex items-start justify-between mb-5">
          <h3 className="font-head text-xl text-white">{title}</h3>
          <button onClick={onClose} data-testid={`${testid}-close`}><X size={20} className="text-slate-400 hover:text-white" /></button>
        </div>
        {children}
      </div>
    </div>
  );
}

export function Field({ label, children }) {
  return (
    <label className="block">
      <span className="text-[11px] uppercase tracking-widest text-slate-500 mb-1 block">{label}</span>
      {children}
    </label>
  );
}

const PILL = { Paid: "#10B981", Partial: "#F59E0B", Pending: "#94A3B8" };

export function PayStatus({ status, testid }) {
  const c = PILL[status] || PILL.Pending;
  return <span data-testid={testid} className="text-[10px] px-2 py-0.5 font-mono uppercase tracking-wide border" style={{ color: c, borderColor: c, background: `${c}14` }}>{status}</span>;
}

export function Empty({ text, testid }) {
  return <div data-testid={testid} className="px-4 py-10 text-center text-sm text-slate-500">{text}</div>;
}
